import {axiosInstance} from "@/api/http";

/**
 * 分页-课程列表查询
 * @param obj
 */
export const getPageList = params => axiosInstance.get('/education-api/paperTest/page',{params})
/**
 * 查询考试详情
 * @param paperId
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getPaperExam = paperId => axiosInstance.get('/education-api/paperTest/getPaperExam/'+paperId)
/**
 * 查询考生试卷
 * @param paperId
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getPaperQuestion = paperId => axiosInstance.get('/education-api/paperTest/getPaperQuestion/'+paperId)

export const getUserExamDetail = paperId => axiosInstance.get('/education-api/paperTest/getUserExamDetail/'+paperId)
/**
 * 查询考试列表
 * @param status
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getMyExamList = params => axiosInstance.get('/education-api/paperTest/getMyExamList', {params})
export const getMyOperationList = params => axiosInstance.get('/education-api/paperTest/getMyOperationList', {params})

export const finishExam = finishExamData => axiosInstance.post('/education-api/paperTest/finishExam',finishExamData)
/**
 * 提交实抄考试
 * @param subOperate
 * @returns {Promise<AxiosResponse<any>>}
 */
export const subOperate = operateData => axiosInstance.post('/education-api/paperTest/saveOperateAssess',operateData)


